// Single source of truth for Explorer content page size (Strategy/Application/KPI/Check-In/Measure explorers).
export enum ExplorerPaginationConfig {
  ContentItemCountPerPage = 45,
}
